var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('transition',{attrs:{"mode":"out-in"}},[_c('router-view',{key:_vm.$route.path})],1)],1),_c('MessageModal'),_c('ReleaseNotesPDF')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }